import * as React from "react";
import './StyledButton.css';

export interface props {
    onClick: React.MouseEventHandler<HTMLButtonElement>
    backgroundColor: string
    disabled?: boolean
    buttonText?: string
    image?: React.ReactNode 
    children?: React.ReactNode
    name?: string
    type?: "button" | "submit" | "reset" | undefined
    props?: any
}

export const StyledButton: React.FC<props> = ({
    onClick, 
    backgroundColor, 
    buttonText, 
    image, 
    children, 
    disabled = false, 
    name,
    type = 'button',
    ...props}): JSX.Element => (
    <>
        <button 
            disabled={disabled} 
            className="styled-button" 
            style={{ backgroundColor: backgroundColor }} 
            onClick={onClick} 
            name={name}
            type={type}>
            <div className="styled-button-content">
                {image ? image : null}
                {buttonText ? buttonText : buttonText}
            </div>
        </button>
    </>
);